import * as api from '../../api/api-solicitud-honorarios';
import { 
    GET_CONFIG_FORM97,
    GET_COMPANIAS,
    GET_ORIGENES,
    GET_SITUACIONES_HONO,
    GET_CONSULTA_HONORARIOS,
    CLEAN_CASOS_HONORARIOS,
    SET_QUERY_STATE_HONORARIOS
} from '../types';

export const configuracionFormAction97 = (query) => ({
    type: GET_CONFIG_FORM97,
    payload: api.getConfiguracionForm97(query)
});
export const obtenerCompanias = (query) => ({
    type: GET_COMPANIAS,
    payload: api.getCompanias(query)
});
export const obtenerOrigenes = (query) => ({
    type: GET_ORIGENES,
    payload: api.getConceptos(query)
});
export const obtenerSituaciones = (query) => ({
    type: GET_SITUACIONES_HONO,
    payload: api.getConceptos(query)
});
export const obtenerConsultaHonorarios = (query) => ({
    type: GET_CONSULTA_HONORARIOS,
    payload: api.getConsultaHonorarios(query)
});
export const limpiarCasos = () => ({
    type: CLEAN_CASOS_HONORARIOS,
});
export const setQueryState = (data) => ({
    type: SET_QUERY_STATE_HONORARIOS,
    payload:data
  
});


